import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  TextField,
  InputAdornment,
  Typography,
  Switch,
  Button,
} from "@mui/material";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SearchIcon } from "../icons";
import { getTrains } from "../services/trainService";
import { isTutorialState } from "../recoil";
import { useSetRecoilState, useRecoilState } from "recoil";
import { handleSelectChange } from "../utils/utils";
import CustomButton from "./customComponent/CustomButton";
import { t } from "i18next";
import { IProjectData } from "@types";
import { func_userConfigUpdate } from "../utils/tutorialUtil";
import { steps_1, steps_1_2, steps_2, steps_3, steps_4 } from "./joyride/step1";
import { useNavigate, useLocation } from "react-router-dom";
import { useTutorial } from "../hooks/useTutorial";
import { getProjects } from "common-lib";

interface SearchSelectOptionProps {
  menuItems: string[];
  searchType: string;
  setSearchType: Dispatch<SetStateAction<string>>;
}
export function SearchSelectOption({
  menuItems,
  searchType,
  setSearchType,
}: SearchSelectOptionProps) {
  return (
    <FormControl>
      <InputLabel>{t("SearchCondition")}</InputLabel>
      <Select
        value={searchType}
        label={t("SearchCondition")}
        sx={{
          color: "var(--text-color)",
        }}
        size="small"
        onChange={handleSelectChange(setSearchType)}
      >
        {menuItems.length > 0 &&
          menuItems.map((menuItem, index) => (
            <MenuItem key={index} value={menuItem}>
              {t(menuItem)}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}

interface MenuProps {
  menu: string;
  setProjectsData?: (project: IProjectData[]) => void;
  setPage?: (page: number) => void;
  keyword: string | null;
  setKeyword: (keyword: string | null) => void;
  type?: string;
  setType?: (type: string) => void;
}

export function SearchComponent({
  menu,
  setProjectsData,
  setPage,
  keyword,
  setKeyword,
  type,
  setType,
}: MenuProps) {
  const userInfo = JSON.parse(
    localStorage.getItem("userInfo")?.toString() || "{}"
  );
  const [isTutorial, setIsTutorial] = useRecoilState(isTutorialState);
  const [tempKeyword, setTempKeyword] = useState<string | null>(null);
  const [isFirstTutorial, setIsFirstTutorial] = useState<boolean>(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { startTutorial, saveTourProgress, resetTutorial, saveProgress } =
    useTutorial();

  let menuItems: string[] = [];
  if (menu === "project") {
    menuItems = ["ProjectName", "MaterialName"];
  }
  if (menu === "train") {
    menuItems = ["TrainName"];
  }
  if (menu === "insp_model") {
    menuItems = ["InspModelName"];
  }
  if (menu === "insp_rule") {
    menuItems = ["InspRuleName"];
  }
  if (menu === "notice") {
    menuItems = ["NoticeTitle", "NoticeContent"];
  }
  const [searchType, setSearchType] = useState<string>(menuItems[0] || "");
  const searchTypeMapping: { [key: string]: string } = {
    ProjectName: "project_name",
    MaterialName: "material_name",
    TrainName: "name",
    InspModelName: "name",
    InspRuleName: "name",
    NoticeTitle: "title",
    NoticeContent: "content",
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  useEffect(() => {
    const saved = localStorage.getItem("tutorialProgress");
    if (saved) {
      setIsFirstTutorial(false);
    } else {
      setIsFirstTutorial(true);
    }
  }, []);

  useEffect(() => {
    // if (setPage) {
    //   setPage(1);
    // }
    // setKeyword(null);
  }, [menu]);

  const handleSearch = async () => {
    const params = {
      [searchTypeMapping[searchType]]: tempKeyword,
    };
    setKeyword(tempKeyword);
    if (setType) {
      setType(searchTypeMapping[searchType]);
    }
    try {
      if (menu === "train") {
        if (setPage) {
          setPage(1);
        }
      }
      if (menu === "insp_model") {
        if (setPage) {
          setPage(1);
        }
      }
      if (menu === "insp_rule") {
        if (setPage) {
          setPage(1);
        }
      }
      if (menu === "project" && setProjectsData) {
        const response = await getProjects({ ...params, page: 1, size: 8 });
        setProjectsData(response.projects.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleStart = () => {
    const saved = localStorage.getItem("tutorialProgress");
    // if (!saved) return;
    let stepIndex = 0;

    if (saved) {
      const { path, stepIndex: savedIndex, series = "" } = JSON.parse(saved);
      if (path === location.pathname) {
        stepIndex = savedIndex;
      }
    } else {
      saveProgress(0, "tour_1");
    }
    startTutorial(location.pathname, stepIndex, "tour_1");
  };

  const handleRestart = () => {
    const saved = localStorage.getItem("tutorialProgress");
    if (saved) {
      const { path, stepIndex, type, series = "" } = JSON.parse(saved);
      if (path === location.pathname) {
        startTutorial(location.pathname, stepIndex, series);
      } else {
        // 페이지가 달라졌다면 그 페이지로 먼저 이동
        navigate(path);
      }
    } else {
      console.log("이전 튜토리얼 정보가 없습니다.");
    }
  };

  return (
    <Box sx={{ display: "flex", gap: "5px" }}>
      {/* TODO: 개발용 튜토리얼 ON/OFF. 위치 바꿀것 */}
      {/* <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
          border: "1px solid lightgray",
          borderRadius: "5px",
          px: 1,
        }}
      >
        <Typography sx={{ alignContent: "center" }}>개발용 튜토리얼</Typography>
        {isFirstTutorial ? (
          <Button
            variant="outlined"
            size="small"
            sx={{
              borderStyle: "dashed",
              borderColor: "gray",
              color: "gray",
              "&:hover": {
                borderStyle: "dashed",
                borderColor: "#333",
                color: "var(--dk-text, #333)",
                backgroundColor: "transparent",
              },
            }}
            onClick={handleStart}
          >
            Start
          </Button>
        ) : (
          <Button
            variant="outlined"
            size="small"
            sx={{
              borderStyle: "dashed",
              borderColor: "gray",
              color: "gray",
              "&:hover": {
                borderStyle: "dashed",
                borderColor: "#333",
                color: "var(--dk-text, #333)",
                backgroundColor: "transparent",
              },
            }}
            onClick={handleRestart}
          >
            ReStart
          </Button>
        )}
        <Button
          variant="outlined"
          size="small"
          sx={{
            borderStyle: "dashed",
            borderColor: "gray",
            color: "gray",
            "&:hover": {
              borderStyle: "dashed",
              borderColor: "#333",
              color: "var(--dk-text, #333)",
              backgroundColor: "transparent",
            },
            ml: 1,
          }}
          onClick={resetTutorial}
        >
          Reset
        </Button>
      </Box> */}

      <SearchSelectOption
        menuItems={menuItems}
        searchType={searchType}
        setSearchType={setSearchType}
      />
      <TextField
        variant="outlined"
        label={t("Search")}
        size="small"
        onChange={(e) => setTempKeyword(e.target.value)}
        onKeyDown={handleKeyPress}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "var(--textfield-icon)" }} />
            </InputAdornment>
          ),
          sx: {
            color: "var(--textfield-text)",
          },
        }}
        InputLabelProps={{
          sx: {
            color: "var(--textfield-label)",
            "&.Mui-focused": {
              color: "var(--textfield-label-focused)",
            },
          },
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "var(--textfield-border)",
            },
            "&:hover fieldset": {
              borderColor: "var(--textfield-border-hover)",
            },
            "&.Mui-focused fieldset": {
              borderColor: "var(--textfield-border-focused)",
            },
          },
        }}
      />
      <CustomButton
        text={t("Search")}
        variant="outlined"
        onClick={handleSearch}
      />
    </Box>
  );
}
